var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBorderly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21Z",
    fill: "#112C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.63 27.63C27.5255 27.7346 27.4014 27.8176 27.2648 27.8742C27.1283 27.9309 26.9819 27.96 26.834 27.96C26.6861 27.96 26.5397 27.9309 26.4031 27.8742C26.2666 27.8176 26.1425 27.7346 26.038 27.63L21 22.59L15.962 27.628C15.7494 27.8304 15.4661 27.9417 15.1726 27.9382C14.8791 27.9346 14.5986 27.8165 14.391 27.609C14.1834 27.4015 14.0651 27.1211 14.0613 26.8276C14.0576 26.5341 14.1687 26.2507 14.371 26.038L19.409 21L14.371 15.962C14.1723 15.7487 14.0641 15.4667 14.0692 15.1752C14.0744 14.8838 14.1924 14.6057 14.3986 14.3996C14.6047 14.1935 14.8828 14.0754 15.1742 14.0702C15.4657 14.0651 15.7477 14.1733 15.961 14.372L21 19.408L26.038 14.37C26.249 14.159 26.5351 14.0405 26.8335 14.0405C27.1319 14.0405 27.418 14.159 27.629 14.37C27.84 14.581 27.9585 14.8671 27.9585 15.1655C27.9585 15.4639 27.84 15.75 27.629 15.961L22.591 21L27.629 26.038C27.7335 26.1425 27.8163 26.2665 27.8729 26.403C27.9294 26.5395 27.9585 26.6858 27.9585 26.8335C27.9585 26.9812 27.9294 27.1275 27.8729 27.264C27.8163 27.4005 27.7335 27.5245 27.629 27.629L27.63 27.63Z",
    fill: "#EAFF99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBorderly);
export default __webpack_public_path__ + "static/media/close-borderly.e4371edafa309ebfa97c92bb0a54e950.svg";
export { ForwardRef as ReactComponent };